import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [state, setState] = useState(location.state?.user ? { ok: true, user: location.state.user } : null);

    useEffect(() => {
        if (location.state?.user) return;
        let live = true;
        (async () => {
            try {
                const res = await fetch(`${API}/auth/me`, { credentials: "include" });
                if (!res.ok) throw new Error("unauthenticated");
                const data = await res.json();
                if (live) setState({ ok: true, user: data });
            } catch {
                if (live) setState({ ok: false });
            }
        })();
        return () => {
            live = false;
        };
    }, [location.state]);

    useEffect(() => {
        if (state && !state.ok) navigate("/login", { replace: true });
    }, [state, navigate]);

    if (!state || !state.ok) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-navy-950" data-testid="protected-route-loading">
                <Loader2 className="animate-spin text-electric" size={28} />
            </div>
        );
    }
    return children(state.user);
};

export default ProtectedRoute;
